(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrinterRemoveOnDeviceConfig(
    toastr, $filter, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printerProperties/printerGoProfile/printerRemoveOnDeviceConfig/printerRemoveOnDeviceConfig.template.html',
      link: function(scope) {

        scope.printer = scope.context;
        scope.confirm = {
          delete: false
        };


        scope.delete = function () {
          var url = scope.printer.info._links['px:onDeviceConfig'].href;
          $http.delete(url).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
          }).catch(function(error) {
            toastr.error($filter('translate')('ERROR'));
          });
          scope.callback();
        }

        scope.$on('$destroy', function() {
        });

      }
    };
  }

  pxPrinterRemoveOnDeviceConfig.$inject = ['toastr', '$filter', '$http'];

  angular
    .module('printix-admin')
    .directive('pxPrinterRemoveOnDeviceConfig', pxPrinterRemoveOnDeviceConfig);

})();
